import { diagnosisGridItemFrag } from '../../../../../services/types/medication.types';
import { medicalProcedureFrag } from '../../../../../services/types/medical-procedure.types';

export const folderAnamnesisUserFrag = `
    id
    name
    surname
    email
    titleAfterName
    titleBeforeName
    image
`;

export const folderAnamnesisFrag = `
    id
    dateFrom
    createdAt
    updatedAt
    dateTo
    bloodType
    anamnesis
    diagnosis {
        ${diagnosisGridItemFrag}
    }
    insuranceAbbr
    isHiv
    isHbsag
    isRwe
    alergies
    operation
    symptoms
    invasives
    importantNote
    note
    socialAnamnesis
    nurseRecommendations
    statusPraesens
    warning
    vaccine
    implants
    medication
    wishes
    folderId
    userId
    doctorId
    user {
        ${folderAnamnesisUserFrag}
    }
    secondaryDiagnoses {
        ${diagnosisGridItemFrag}
    }
    medicalProcedures {
        ${medicalProcedureFrag}
    }
`;
